export default "__VITE_ASSET__CxTkAHjc__"